// extracted by mini-css-extract-plugin
export default {"root":"TableAnalyze_root__gwYqv","tableBodyScroll":"TableAnalyze_tableBodyScroll__+r4S2","tableBody":"TableAnalyze_tableBody__U5Cvp","tableHeader":"TableAnalyze_tableHeader__Qktqe"};